import React, {PropTypes} from "react";
import {connect} from "react-redux";
import AutoComplete from 'material-ui/AutoComplete';
import RaisedButton from 'material-ui/RaisedButton';

class RequestAccessAppAutomplete extends React.Component {

  constructor() {
    super();
    this.state = ({selected: false, option: null});
  }

  render() {
    let dataSource = new Array();
    this.props.applications.map((node)=>{
      dataSource.push(node.appName);
    })
    return (
      <div>
        <AutoComplete
          openOnFocus = {true}
          floatingLabelText = "Enter Application Name"
          filter={AutoComplete.caseInsensitiveFilter}
          onUpdateInput={(event)=>{
            if(this.props.applications.indexOf(event)<0)
            {
              this.setState({selected: false});
            }
            else {
              this.setState({selected: true, option: event})
            }
            }}
          onNewRequest={(event)=>{
            this.setState({option: event,selected: true})
          }}
          dataSource={dataSource}
        />   &nbsp; &nbsp;
        <RaisedButton disabled={!this.state.selected}
                      label="Request Access"
                      primary={true}
                      onClick={()=>{
                        console.log(this.state.selected);
                        console.log(this.state.option);
                        this.props.onRequestAccess(this.state.option);
                        //Send data to parent component and open a model
                      }}
        />
      </div>
    );
  }
}

RequestAccessAppAutomplete.defaultProps= {
  applications: ["App1","App2","App3"]
}

export default (RequestAccessAppAutomplete);



/** WEBPACK FOOTER **
 ** ./src/feature/appAccess/MyApplications/components/RequestAccessAppAutoComplete.js
 **/